var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 32,
    viewBox: "0 0 53 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 32,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 18.5C35.8284 18.5 36.5 17.8284 36.5 17C36.5 16.1716 35.8284 15.5 35 15.5L35 18.5ZM9.93934 15.9393C9.35355 16.5251 9.35355 17.4749 9.93934 18.0607L19.4853 27.6066C20.0711 28.1924 21.0208 28.1924 21.6066 27.6066C22.1924 27.0208 22.1924 26.0711 21.6066 25.4853L13.1213 17L21.6066 8.51472C22.1924 7.92893 22.1924 6.97919 21.6066 6.3934C21.0208 5.80761 20.0711 5.80761 19.4853 6.3934L9.93934 15.9393ZM35 15.5L11 15.5L11 18.5L35 18.5L35 15.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.cb4e9c788357485134f986a79a5de556.svg";
export { ForwardRef as ReactComponent };